<template>
  <transition :name="transitionName">
    <div :class="classes" :style="styles">
      <div ref="content" :class="[baseClass + '-content']" v-html="content"></div>
      <a v-if="closable" :class="[baseClass + '-close']" @click="_close()">
        <i class="aid aid-close"></i>
      </a>
    </div>
  </transition>
</template>
<script>
import {PREFIX_CLASS} from '../../../utils/constants'

export default {
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 1.5
    },
    content: {
      type: String,
      default: ''
    },
    styles: {
      type: Object,
      default: function () {
        return {
          right: '50%'
        }
      }
    },
    closable: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: true
    },
    className: {
      type: String
    },
    name: {
      type: String,
      required: true
    },
    onClose: {
      type: Function
    },
    transitionName: {
      type: String
    },
    timeOutId: {
      type: Number
    }
  },
  data () {
    return {
      withDesc: false
    }
  },
  computed: {
    baseClass () {
      return `${this.prefixCls}-notice`
    },
    classes () {
      return [
        this.baseClass,
        {
          [`${this.className}`]: !!this.className,
          [`${this.baseClass}-closable`]: this.closable,
          [`${this.baseClass}-with-desc`]: this.withDesc
        }
      ]
    },
    contentClasses () {
      return `${this.baseClass}-content`
    }
  },
  mounted () {
    // this._clearCloseTimer()
    // 初始化持续时间
    let closeTimer
    if (this.duration !== 0) {
      closeTimer = setTimeout(() => {
        // 到达持续时间后调用关闭方法
        this._close()
      }, this.duration * 1000)
    }
    this.$emit('notice-time-out', closeTimer, this.name)
    // check if with desc in Notice component
    if (this.prefixCls === `${PREFIX_CLASS}notice`) {
      this.withDesc = this.$refs.content.querySelectorAll(`.${this.prefixCls}-desc`)[ 0 ].innerHTML !== ''
    }
  },
  beforeDestroy () {
//    this._clearCloseTimer()
  },
  methods: {
    // 设置私有方法
    _clearCloseTimer () {
      if (this.timeOutId) {
        clearTimeout(this.timeOutId)
      }
    },
    // 设置为私有方法
    _close () {
      this.onClose()
      this.$parent.close(this.name)
      this._clearCloseTimer()
    }
  }
}
</script>



// WEBPACK FOOTER //
// notice.vue?17bec50a